/*
 * @format
 */

// Passkey endpoints on the Halo API. The WebAuthn options and responses are
// plain JSON rather than JSON:API: the native passkey module produces and
// consumes that exact shape, and the JSON:API client would rename keys such
// as clientDataJSON.

import { fetchAuthSession } from 'aws-amplify/auth';
import config from '../../env';

export class PasskeyApiError extends Error {
  constructor(status, code, message) {
    super(message);
    this.name = 'PasskeyApiError';
    this.status = status;
    this.code = code;
  }
}

async function request(path, { method = 'GET', body } = {}) {
  const session = await fetchAuthSession();

  const response = await fetch(
    `${config.halo_api_endpoint}/halo/passkeys${path}`,
    {
      method,
      headers: {
        Authorization: session.tokens.idToken.toString(),
        'Content-Type': 'application/json',
      },
      body: body === undefined ? undefined : JSON.stringify(body),
    },
  );

  const text = await response.text();
  const data = text ? JSON.parse(text) : null;

  if (!response.ok) {
    const error = data?.errors?.[0];
    throw new PasskeyApiError(
      response.status,
      error?.code,
      error?.title || `Passkey request failed (${response.status})`,
    );
  }

  return data;
}

export const getRegistrationOptions = () =>
  request('/registration-options', { method: 'POST' });

export const registerPasskey = (deviceName, credential) =>
  request('', { method: 'POST', body: { deviceName, credential } });

/** Resolves to [{ id, DeviceName, CreatedAt, LastUsedAt, BackedUp }] */
export async function listPasskeys() {
  const data = await request('');
  return (data?.data || []).map(item => ({ id: item.id, ...item.attributes }));
}

export const deletePasskey = credentialId =>
  request(`/${encodeURIComponent(credentialId)}`, { method: 'DELETE' });
